"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appThemeContractSchema = exports.APP_THEME_CONTRACT_VERSION = void 0;
exports.parseAppThemeContract = parseAppThemeContract;
const zod_1 = require("zod");
exports.APP_THEME_CONTRACT_VERSION = "1.0";
const cssHexColorSchema = zod_1.z
    .string()
    .regex(/^#[0-9a-f]{6}$/i, "A six-digit hexadecimal color is required.");
const cssOklchColorSchema = zod_1.z
    .string()
    .regex(/^oklch\(\s*(?:(?:0|1|0?\.\d+)|(?:100(?:\.0+)?|\d{1,2}(?:\.\d+)?|\.\d+)%)\s+(?:0|0?\.\d+)\s+\d+(?:\.\d+)?\s*\)$/i, "A canonical OKLCH color is required.");
const cssLabColorSchema = zod_1.z
    .string()
    .regex(/^lab\(\s*(?:\d+(?:\.\d+)?|\.\d+)%\s+[+-]?(?:\d+(?:\.\d+)?|\.\d+)\s+[+-]?(?:\d+(?:\.\d+)?|\.\d+)\s*\)$/i, "A canonical LAB color is required.");
const cssColorSchema = zod_1.z.union([
    cssHexColorSchema,
    cssOklchColorSchema,
    cssLabColorSchema,
]);
const cssRadiusSchema = zod_1.z
    .string()
    .regex(/^(?:\d+(?:\.\d+)?|\.\d+)(?:px|rem)$/, "A px or rem length is required.")
    .refine((value) => {
    const amount = Number.parseFloat(value);
    return value.endsWith("rem")
        ? amount >= 0.375 && amount <= 0.625
        : amount >= 6 && amount <= 10;
}, "App radii must resolve to 6px through 10px.");
exports.appThemeContractSchema = zod_1.z.object({
    version: zod_1.z.literal(exports.APP_THEME_CONTRACT_VERSION),
    mode: zod_1.z.literal("LIGHT"),
    colors: zod_1.z.object({
        background: cssColorSchema,
        surface: cssColorSchema,
        foreground: cssColorSchema,
        mutedForeground: cssColorSchema,
        primary: cssColorSchema,
        primaryForeground: cssColorSchema,
        accent: cssColorSchema,
        accentForeground: cssColorSchema,
        border: cssColorSchema,
        input: cssColorSchema,
        ring: cssColorSchema,
        success: cssColorSchema,
        warning: cssColorSchema,
        danger: cssColorSchema,
        info: cssColorSchema,
    }),
    typography: zod_1.z.object({
        fontFamily: zod_1.z.string().trim().min(1).max(240),
        fontWeightRegular: zod_1.z.number().int().min(100).max(900),
        fontWeightMedium: zod_1.z.number().int().min(100).max(900),
        fontWeightSemibold: zod_1.z.number().int().min(100).max(900),
        fontWeightBold: zod_1.z.number().int().min(100).max(900),
    }),
    shape: zod_1.z.object({
        radiusSmall: cssRadiusSchema,
        radiusMedium: cssRadiusSchema,
        radiusLarge: cssRadiusSchema,
    }),
});
function parseAppThemeContract(input) {
    return exports.appThemeContractSchema.parse(input);
}
//# sourceMappingURL=theme.js.map